<div class="container">
  <div class="Login_wrapper d-flex flex-column">
    <div class="Login_wrapper_header">
      <h1 class="">Forgot your password?</h1>
      <h5 class="mt-3">Let's retreva it.</h5>
    </div>
    <div class="Login_wrapper_body p-5">
      <form [formGroup]="formGroup">
        <div class="row align-items-center mb-3">
          <div class="col col-2">
            <mat-label>Email</mat-label>
          </div>
          <div class="col col-10">
            <app-text-field
              placeholder="Email address"
              type="email"
              formControlName="email"></app-text-field>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <app-button
            class="Login_wrapper_body_button"
            [text]="submitButtonProperties.text"
            [color]="submitButtonProperties.color"
            [Click]="submitButtonProperties.onClick"
            [size]="submitButtonProperties.size"></app-button>
        </div>
        <div
          class="Login_wrapper_body_footer mt-3 d-flex justify-content-center flex-column">
          <p>Back to <a [routerLink]="['/login']" class="forg">Login</a></p>
          <p class="mt-2">
            Don't have an account. <a [routerLink]="['/register']">Sign up.</a>
          </p>
        </div>
      </form>
    </div>
  </div>
</div>
